import { Button } from '~/shadcn/ui/button/button'

type Props = {
  isEnabled: boolean
  onActivate: () => void
  onDeactivate: () => void
}

export function AmbassadorStatusAction({
  isEnabled,
  onActivate,
  onDeactivate,
}: Props) {
  return (
    <div className="flex flex-col gap-4">
      <h4 className="text-base font-bold text-primary">Akcia</h4>
      {isEnabled ? (
        <Button
          variant="ghost"
          onClick={onDeactivate}
          className="h-[21px] self-start px-0">
          <span className="text-sm font-bold text-red underline">
            Deaktivovať ambasádora
          </span>
        </Button>
      ) : (
        <Button
          variant="ghost"
          onClick={onActivate}
          className="h-[21px] self-start px-0">
          <span className="text-sm font-bold text-accent underline">
            Aktivovať ambasádora
          </span>
        </Button>
      )}
    </div>
  )
}
